var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"camera-tts-btn flex items-center gap-2 px-3 py-2 rounded",style:(_vm.btnStyle),attrs:{"disabled":_vm.loading},on:{"click":_vm.handleClick}},[_c('feather-icon',{staticClass:"w-4 h-4",attrs:{"icon":_vm.iconName}}),_c('span',[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }